import request from '@/utils/request'

/** 友情链接列表（含已下架的，管理端要能看到全貌） */
export function getFriendLinkList() {
  return request({
    url: '/admin/friend-link/list',
    method: 'get'
  })
}

/** 新增 */
export function createFriendLink(data) {
  return request({
    url: '/admin/friend-link',
    method: 'post',
    data
  })
}

/** 编辑 */
export function updateFriendLink(id, data) {
  return request({
    url: '/admin/friend-link/' + id,
    method: 'put',
    data
  })
}

/** 上架 / 下架（取反，不需要传目标状态） */
export function toggleFriendLink(id) {
  return request({
    url: '/admin/friend-link/' + id + '/toggle',
    method: 'put'
  })
}

/** 删除 */
export function deleteFriendLink(id) {
  return request({
    url: '/admin/friend-link/' + id,
    method: 'delete'
  })
}
